const truth = (x) => Boolean(x);
export default truth;
